import { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";

import { getCurios, postCourierStartWork } from "../../../MyApi/curior";
import { getShifts } from "../../../MyApi/shifts";

const StartCourierWorkModal = ({
  show,
  onClose,
  refetch,
  storeId,
}) => {
  const [formData, setFormData] = useState({
    courier_id: "",
    shift_template_id: "",
  });

  useEffect(() => {
    if (!show) {
      setFormData({
        courier_id: "",
        shift_template_id: "",
      });
    }
  }, [show]);

  // Couriers
  const { data: couriersData, isLoading: couriersLoading } = useQuery(
    ["couriers"],
    () => getCurios(),
    {
      enabled: show,
      refetchOnWindowFocus: false,
    }
  );

  const couriers =
    couriersData?.data?.couiers ||
    couriersData?.data?.couriers ||
    [];

  // Shifts
  const { data: shiftsData, isLoading: shiftsLoading } = useQuery(
    ["getshifts"],
    () => getShifts(),
    {
      enabled: show,
      refetchOnWindowFocus: false,
    }
  );

  const shifts = shiftsData?.data?.templates || [];

  const mutation = useMutation(
    (postData) => postCourierStartWork(postData),
    {
      onSuccess: (res) => {
        toast.success(
          res?.message || "تم تسجيل بدء الدوام بنجاح"
        );

        setFormData({
          courier_id: "",
          shift_template_id: "",
        });

        refetch?.();
        onClose?.();
      },

      onError: (err) => {
        toast.error(
          err?.response?.data?.message ||
            "حدث خطأ أثناء تسجيل بدء الدوام"
        );
      },
    }
  );

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();

    if (!formData.courier_id) {
      toast.error("يرجى اختيار السائق");
      return;
    }

    if (!formData.shift_template_id) {
      toast.error("يرجى اختيار موعد العمل");
      return;
    }

    mutation.mutate({
      couier_id: Number(formData.courier_id), // API uses couier_id
      shift_template_id: Number(formData.shift_template_id),
    });
  };

  const handleClose = () => {
    setFormData({
      courier_id: "",
      shift_template_id: "",
    });

    onClose?.();
  };

  return (
    <Modal isOpen={show} toggle={handleClose} className="add">
      <ModalHeader toggle={handleClose}>
        بدء دوام سائق
      </ModalHeader>

      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label>السائق</Label>

            <Input
              type="select"
              name="courier_id"
              value={formData.courier_id}
              onChange={handleChange}
              disabled={couriersLoading}
            >
              <option value="">
                {couriersLoading
                  ? "جاري تحميل السائقين..."
                  : "اختر السائق"}
              </option>

              {couriers.map((courier) => (
                <option
                  key={courier.id}
                  value={courier.id}
                >
                  {courier.name}
                </option>
              ))}
            </Input>
          </FormGroup>

          <FormGroup>
            <Label>موعد العمل</Label>

            <Input
              type="select"
              name="shift_template_id"
              value={formData.shift_template_id}
              onChange={handleChange}
              disabled={shiftsLoading}
            >
              <option value="">
                {shiftsLoading
                  ? "جاري تحميل المواعيد..."
                  : "اختر موعد العمل"}
              </option>

              {shifts.map((shift) => (
                <option
                  key={shift.id}
                  value={shift.id}
                >
                  {shift.name}
                </option>
              ))}
            </Input>
          </FormGroup>
        </Form>
      </ModalBody>

      <ModalFooter>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={mutation.isLoading}
        >
          {mutation.isLoading
            ? "جاري الحفظ..."
            : "تأكيد"}
        </Button>

        <Button
          color="danger"
          onClick={handleClose}
          disabled={mutation.isLoading}
        >
          إلغاء
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default StartCourierWorkModal;